<template>
  <div>
    <label v-if="label" class="form-label" :for="id">{{ label }}: <i v-if="optional" class="text-gray-400 text-sm">optionnelle</i></label>
    <textarea :id="id" ref="input" v-bind="$attrs" class="form-textarea" :class="{ error: error,'bg-gray-100': disabled }" :value="value" @input="$emit('input', $event.target.value)" />
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `textarea-input-${this._uid}`
      },
    },
    value: String,
    label: String,
    error: String,
    optional: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
  },
}
</script>
